export const UPDATE_VISIBILITY = "RegionSelectionBanner: Update visibility";

export function updateVisibility(isVisible: boolean) {
  return {
    type: UPDATE_VISIBILITY,
    payload: {
      isVisible,
    },
  };
}
